import { render } from "./installationCreate.vue?vue&type=template&id=4355e0a8&scoped=true"
import script from "./installationCreate.vue?vue&type=script&lang=js"
export * from "./installationCreate.vue?vue&type=script&lang=js"

import "./installationCreate.vue?vue&type=style&index=0&id=4355e0a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4355e0a8"]])

export default __exports__